import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { CheckCircle2Icon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
export function ArticleHeader() {
  return <header className="mb-10" data-id="element-29">
      <FadeIn data-id="element-30">
        <h1 className="text-3xl md:text-4xl lg:text-[44px] font-extrabold text-[#111] text-center leading-tight mb-4 max-w-4xl mx-auto" data-id="element-31">
          Homeowners Are Saving $2,000+ on Windows — Are You Overpaying?
        </h1>

        <p className="text-lg md:text-xl text-[#444] text-center mb-8 max-w-2xl mx-auto font-medium" data-id="element-32">
          Get your free local price check in under 60 seconds. No calls, no
          commitment.
        </p>

        <div className="flex justify-center mb-6" data-id="element-33">
          <CTAButton data-id="element-34">See My Local Prices</CTAButton>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 mb-10 text-sm md:text-base text-[#555] font-medium" data-id="element-35">
          <div className="flex items-center gap-1.5" data-id="element-36">
            <ShieldCheckIcon className="w-5 h-5 text-green-600" data-id="element-37" />
            <span data-id="element-38">Free & No Obligation</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-39">
            <ClockIcon className="w-5 h-5 text-green-600" data-id="element-40" />
            <span data-id="element-41">Takes 60 Seconds</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-42">
            <CheckCircle2Icon className="w-5 h-5 text-green-600" data-id="element-43" />
            <span data-id="element-44">47,000+ Homeowners Checked</span>
          </div>
        </div>

        <div className="w-full max-w-3xl mx-auto rounded-2xl overflow-hidden shadow-md" data-id="element-45">
          <img src="https://cdn.magicpatterns.com/uploads/gGWaqXtfC6Vmo9PHf22cXs/como-cambiar-ventanas.jpg" alt="Dos trabajadores reemplazando una ventana" className="w-full h-auto object-cover max-h-[280px]" loading="eager" data-id="element-46" />
        </div>
      </FadeIn>
    </header>;
}